import React, { useContext } from 'react';
import IconAndTextComponent from '../components/IconAndTextComponent';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { ContextUserProfile } from '../../contexts/UserProfileContext';
import { ContextSettings } from '../../contexts/SettingsContext';
import { languagesMenu } from '../../utils/menusData';
import useTranslate from '../../customHooks/useTranslate';
import useLanguage from '../../customHooks/useLanguage';

const NonEditionContent = () => {
    const { readOnlyUser, theme } = useContext(ContextUserProfile);
    const language = useLanguage();
    const { selectedTimezone, setIsEditionMode } = useContext(ContextSettings);
    const translate = useTranslate();
    const selectedLanguage = useTranslate(
        languagesMenu.find(lang => lang.text === language).name
    );

    return (
        <>
            {!readOnlyUser && (
                <Tooltip title={translate('edit')} placement='top'>
                    <IconButton
                        onClick={() => setIsEditionMode(true)}
                        className='edit-button'
                    >
                        <EditIcon />
                    </IconButton>
                </Tooltip>
            )}

            <div className='account-info__non-edition'>
                <IconAndTextComponent
                    icon={'Language'}
                    text={selectedLanguage}
                    description={'language'}
                />
                <IconAndTextComponent
                    icon={'AccessTime'}
                    text={selectedTimezone.DisplayName}
                    description={'time_zone'}
                />
                <IconAndTextComponent
                    icon={'ColorLens'}
                    text={translate(theme)}
                    description={translate('theme')}
                />
            </div>
        </>
    );
};

export default NonEditionContent;
